<div
    class="card dynamic-task-card"
    [ngClass]="{
        'dynamic-delivering-card': !isDone,
        'dynamic-done-card': isDone,
        'dynamic-card-expanded': !isCollapsed
    }"
    [ngStyle]="{
        border:
            !isDone && task.multipickingTaskIdentifierColor
                ? '2px solid ' + task.multipickingTaskIdentifierColor
                : 'none'
    }"
>
    <span
        *ngIf="badgeText && !groupCollapsed"
        class="dynamic-sequence-number"
        aria-hidden="true"
    >
        {{ badgeText }}
    </span>
    <div class="card-header" (click)="toggleCard()">
        <div class="dynamic-task-selector">
            <span class="dynamic-completed-check">
                <i class="fa fa-check"></i>
            </span>
        </div>
        <div class="dynamic-task-summary">
            <div class="dynamic-task-title">
                #{{ task.orderCode }} &middot; {{ task.customerZipCode }},
                {{ task.providerName }}, {{ task.orderItemNumber }} SKU
            </div>
            <div *ngIf="task.deliveryTimeSlot || !isDone" class="dynamic-task-metadata">
                <span
                    *ngIf="task.deliveryTimeSlot"
                    class="dynamic-task-meta dynamic-task-timeslot"
                    [attr.title]="'my-tasks.delivery-deadline' | translate"
                >
                    <i class="fa fa-clock-o" aria-hidden="true"></i>
                    {{ task.deliveryTimeSlot }}
                </span>
                <span *ngIf="!isDone" class="dynamic-task-meta">
                    <i class="fa fa-map-marker" aria-hidden="true"></i>
                    ETA: {{ task.estimatedStartDate | amDateFormat : 'H.mm' }}
                </span>
            </div>
        </div>
        <span *ngIf="isDone" class="dynamic-done-label">
            {{ 'my-tasks.done' | translate }}
        </span>
        <button
            *ngIf="!isDone"
            type="button"
            class="btn dynamic-icon-button"
            (click)="showCheckModal($event)"
            [attr.aria-label]="'my-tasks.product-list' | translate"
        >
            <i class="fa fa-list-ul"></i>
        </button>
        <div
            class="dynamic-multi-picking-identifier"
            *ngIf="task.multipickingTaskIdentifierChar"
            [ngStyle]="{
                'background-color': task.multipickingTaskIdentifierColor
            }"
        >
            {{ task.multipickingTaskIdentifierChar }}
        </div>
    </div>

    <div
        *ngIf="!isDone"
        class="card-body dynamic-task-details"
        [collapse]="isCollapsed"
        [isAnimated]="true"
    >
        <h5 class="card-title text-center">{{ task.customerName }}</h5>
        <div class="table-responsive dynamic-task-details-table">
            <table class="table table-striped table-borderless text-white">
                <tbody>
                    <tr>
                        <th scope="row">{{ 'common.provider-shop' | translate }}:</th>
                        <td>{{ task.providerShop }}</td>
                    </tr>
                    <tr>
                        <th scope="row">
                            {{ 'my-tasks.delivery-address' | translate }}:
                        </th>
                        <td>
                            <a
                                href="http://maps.google.com/maps?q={{
                                    task.deliveryAddress
                                }}"
                                class="text-white"
                                target="_blank"
                            >
                                <u>{{ task.deliveryAddress }}</u>
                            </a>
                        </td>
                    </tr>
                    <tr
                        [ngClass]="{
                            'bg-danger':
                                PaymentType[task.paymentType] === 'PayOnDeliveryCash'
                        }"
                    >
                        <th scope="row">{{ 'common.payment-type' | translate }}:</th>
                        <td>
                            {{
                                'payment-type.' +
                                    PaymentType[task.paymentType].toLowerCase()
                                    | translate
                            }}
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">{{ 'common.phone' | translate }}:</th>
                        <td>
                            <a href="tel:{{ task.customerPhone }}" class="text-white">
                                <u>{{ task.customerPhone }}</u>
                            </a>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">{{ 'my-tasks.total-price' | translate }}:</th>
                        <td>
                            {{ task.customerPaidTotalPrice + task.deliveryFee }}
                            {{ 'common.currency' | translate }}
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">{{ 'my-tasks.order-code' | translate }}:</th>
                        <td>{{ task.orderCode }}</td>
                    </tr>
                    <tr>
                        <th scope="row">
                            {{ 'my-tasks.delivery-deadline' | translate }}:
                        </th>
                        <td>
                            <span>{{
                                task.deliveryDeadline
                                    | amAdd : task.timeSlotVisualShiftMinutes : 'minutes'
                                    | amDateFormat : 'HH:mm'
                            }}</span>
                            <span *ngIf="task.deliveryTimeSlotEnd != null">
                                -
                                {{
                                    task.deliveryDeadline
                                        | amAdd
                                            : task.deliveryTimeSlotEnd +
                                                  task.timeSlotVisualShiftMinutes
                                            : 'minutes'
                                        | amDateFormat : 'HH:mm'
                                }}
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">{{ 'common.notes' | translate }}:</th>
                        <td>{{ task.notes }}</td>
                    </tr>
                    <tr *ngIf="task.superOrderCode">
                        <th scope="row">{{ 'common.deliverer-notes' | translate }}:</th>
                        <td>{{ task.delivererNotes }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <app-deliverer-notes
            *ngIf="!task.superOrderCode"
            [isVisible]="isDelivererNotesVisible"
            [orderID]="task.orderID"
            [delivererNotes]="task.delivererNotes"
        ></app-deliverer-notes>
    </div>
    <div *ngIf="!isDone" [collapse]="isCollapsed" [isAnimated]="true">
        <app-wish-list-buttons
            [orderCode]="task.orderCode"
            [customerPhone]="task.customerPhone"
            [wishListOrders]="task.wishListOrders"
        ></app-wish-list-buttons>
    </div>
    <div
        *ngIf="
            !isDone &&
            ('static-links.roksh-return-deposit-link-available' | translate) == 'true'
        "
    >
        <div
            class="btn btn-light p-2 m-2"
            [routerLink]="['/return-deposit']"
            [queryParams]="{
                depositformurl:
                    'static-links.roksh-return-deposit-link'
                    | translate
                        : {
                              orderCode: task.orderCode,
                              customerEmail: task.customerEmail,
                              delivererIdentifier: task.username,
                              delivererEmail: task.delivererEmail
                          }
            }"
        >
            {{ 'deposit.return-deposit-button' | translate }}
        </div>
    </div>
    <div *ngIf="!isDone" class="card-footer" [collapse]="isCollapsed" [isAnimated]="true">
        <app-delivering-task-button [task]="task"></app-delivering-task-button>
    </div>
</div>
